import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import * as Yup from "yup";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  fetchApidata,
  explorePostData,
  postData,
  getFetchData,
  requestMail,
  getLeaveentryData,
  RegGetData,

} from "../../../store/reducers/Formapireducer";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from "@mui/icons-material/Grading";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import Listviewpopup from "../Lookup";
import Popup from "../popup";
import { toast } from "react-hot-toast";
import { Productautocomplete } from "../../../ui-components/global/Autocomplete";
import { formGap } from "../../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../../store/reducers/Listviewapireducer";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import axios from "axios";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import CryptoJS from 'crypto-js';
// import ErrorMsgData from "../../Security/validationMsg.json"

// const validationSchema = Yup.object().shape({
//   Status: Yup.string().required(ErrorMsgData.Regularization.Status),
//   remarks: Yup.string().required(ErrorMsgData.Regularization.remarks),
//   CheckInDate: Yup.string().required(ErrorMsgData.Regularization.CheckInDate),
// });
const KEY = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse('1234567890123456');  // 16-byte IV


export function encryptDataUrlSafe(plainText) {
  const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(); // Standard base64

  // Convert to URL-safe base64
  return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decryptData(encryptedBase64) {
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
    KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8); // Original string
}

const EditRegularization = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const [responseMsg, setResponseMsg] = useState(false);
  const [checkIN, setCheckIN] = useState("");


  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");

  const [open, setOpen] = useState(false);

  const location = useLocation();
  const rowData = location.state || {};
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };

  const mode = params.Mode;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const listViewColumn = useSelector((state) => state.listviewApi.columnData);

  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData
  );
  const explorelistViewColumn = useSelector(
    (state) => state.exploreApi.explorecolumnData
  );
  const RegData = useSelector((state) => state.formApi.RegGetData);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const LeaveEntryData = useSelector((state) => state.formApi.LeaveEntryData);
  console.log(RegData, "--RegData");

  const data = useSelector((state) => state.formApi.Data);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const Data = useSelector((state) => state.formApi.Data);
  const [openDEPopup, setOpenDEPopup] = useState(false);
  const [openADPopup, setOpenADPopup] = useState(false);
  const [openLETPopup, setOpenLETPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imgloading, setimgLoading] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const compID = sessionStorage.getItem("companyId");
  var accessID = params.accessID;
  const currentDate = new Date().toISOString().split("T")[0];
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)
  const EmpName = sessionStorage.getItem("EmpName");
  const VISIBLE_FIELDS = ["SLNO", "Date", "NumberOfHours", "action"];
  const columns = React.useMemo(
    () =>
      explorelistViewColumn
        ? explorelistViewColumn.filter((column) =>
          VISIBLE_FIELDS.includes(column.field)
        )
        : [],
    [explorelistViewColumn]
  );
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({

          remarks: Yup.string().required(data.Regularization.remarks),
          CheckInDate: Yup.string().required(data.Regularization.CheckInDate),
          // managerComments: Yup.string().required(data.Regularization.managerComments),
          managerComments:
            mode === "M" ||
              (mode === "E" && (Data.Status === "RJ" || Data.Status === "QR"))
              ? Yup.string().required(
                data?.Regularization?.managerComments || "Manager Comments is required"
              )
              : Yup.string().notRequired(),

          AppliedStatus: mode === "M" ? Yup.string().required(data.Regularization.Status) : Yup.string().notRequired(),

        });

        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [mode, Data.Status]);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
      console.log(res, "response");

      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: data.EmployeeID,
            appId: recID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    })
  }, []);
  const [selectedLeavetypeOptions, setSelectedLeavetypeOptions] =
    useState(null);
  const [selectedLeavetypeid, setSelectedLeavetypeid] = useState(null);
  const [selectedLeavetypeName, setSelectedLeavetypeName] = useState(null);

  const handleSelectionLeavetypename = (newValue) => {
    if (newValue) {
      //Leavetype
      setSelectedLeavetypeOptions(newValue);
      console.log(newValue, "--setSelectedLeavetypeOptions");
      setSelectedLeavetypeid(newValue.RecordID);

      //setSelectedLeavetypeid(newValue.LeavetypeRecordID);
      setSelectedLeavetypeName(newValue.Name);
    } else {
      setSelectedLeavetypeOptions(null);
      setSelectedLeavetypeid(null);
      setSelectedLeavetypeName(null);
    }
  };

  var userimg = store.getState().globalurl.imageUrl;
  if (mode === "A" || !data?.ImageName) {
    userimg = userimg + "Defaultimg.jpg";
  } else {
    userimg = userimg + data.ImageName;
  }

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate(-1);
      }
    });
  };

  // let params = useParams();
  const dispatch = useDispatch();
  var recID = params.id;

  // var mode = params.Mode;

  /*************************LOOKUP DATA*********************/
  const [openLTpopup, setOpenLTpopup] = useState(false);
  // const validationSchema = Yup.object().shape({
  //   Status: Yup.object()
  //     .nullable()
  //     .required("Status is required"),
  // });
  function handleShow(type) {
    if (type == "LT") {
      setOpenLTpopup(true);
    }
  }
  const [isPopupData, setisPopupdata] = React.useState(false);
  const [selectltLookupData, setselectLTLookupData] = React.useState({
    LTlookupID: "",
    LTlookupCode: "",
    LTlookupDesc: "",
  });

  if (isPopupData == false) {
    selectltLookupData.LTlookupID = Data.LeaveTypeID;
    selectltLookupData.LTlookupCode = Data.LeaveTypeCode;
    selectltLookupData.LTlookupDesc = Data.LeaveTypeName;
  }

  const RegInitialValue = {
    Name: mode === "A" ? RegData.EmployeeName : data.EmployeeName,
    CheckInDate:
      mode === "A" ? RegData.CheckInDate || checkIN : data.CheckInDate,
    CheckOutDate: mode === "A" ? RegData.CheckOutDate : data.CheckOutDate,
    MonthDate: mode === "A" ? currentDate : data.RegularizationDate,
    EmplyeeCheckInDateTime:
      mode === "A" ? RegData.CheckInTime : data.NewCheckInTime,
    // oldCheckinTime: mode === "A" ? RegData.CheckOutDate : data.CheckInTime,
    // oldcheckoutTime: mode === "A" ? RegData.CheckOutDate : data.CheckInTime,
    oldCheckinTime: mode === "A" ? RegData.CheckInTime : data.CheckInTime,
    oldcheckoutTime: mode === "A" ? RegData.CheckOutTime : data.CheckOutTime,
    EmplyeeCheckOutDateTime:
      mode === "A" ? RegData.CheckOutTime : data.NewCheckOutTime,
    Status: data.Status,
    AppliedStatus: mode === "M" ? "" : data.AppliedStatus,


    // Status:
    //   data.Status == "R" ? "Present"
    //     : data.Status == "A" ? "Absent"
    //       : data.Status == "W" ? "WeekOff"
    //         : data.Status == "I" ? "Irregular"
    //           : data.Status == "L" ? "Leave"
    //             : "",
    remarks: mode === "A" ? RegData.Remarks : data.Remarks,
    managerComments: mode === "M" ? Data.ManagerComments : "",
  };

  const REGfnSave = async (values, resetForm, del) => {
    setLoading(true);
    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: data.RecordID,
      EmployeeID: mode == "M" ? params.parentID : EMPID,
      RegularizationDate: values.MonthDate,
      CheckInDate: values.CheckInDate,
      CheckOutDate: values.CheckOutDate,
      CheckInTime: values.oldCheckinTime,
      CheckOutTime: values.oldcheckoutTime,
      Status: values.Status,
      //  Status: values.Status == "QR" ? "AL" : values.Status, Status: mode == "A" ? "AL" : mode == "E" && values.Status == "QR" ? "AL" : values.Status
      Remarks: values.remarks,
      NewCheckInDate: values.CheckInDate,
      NewCheckOutDate: values.CheckOutDate,
      NewCheckInTime: values.EmplyeeCheckInDateTime,
      NewCheckOutTime: values.EmplyeeCheckOutDateTime,
      NewStatus: values.Status,
      AppliedDate: "",
      Reason: "",
      ManagerComments: values.managerComments,
      AppliedStatus:
        mode == "A"
          ? "AL"
          : mode == "E" && values.AppliedStatus == "QR"
            ? "AL"
            : values.AppliedStatus,
      AssignedBy: "",
      AssignedDate: "",

      // AppliedStatus: mode == "A" ? "AL" : values.AppliedStatus,
      Source: "Cloud",
    };
    const response = await dispatch(
      postData({ accessID: "TR219", action, idata })
    );
    if (response.payload.Status == "Y") {
      setLoading(false);
      if (mode == "A") {
        dispatch(
          requestMail({
            EmployeeID: EMPID,
            Type: "RG",
            RecordID: response.payload.RegRecID,
            encryptData: encryptDataUrlSafe(response.payload.RegRecID)
          })
        );
        dispatch(
          leaveAppoval({
            data: {
              RecordID: response.payload.RegRecID,
              ManagerID: "",
              EmployeeID: EMPID,
              Type: "RG",
              Status: "AL",
              Reason: values.comments,
            },
          })
        );
      }

      if (mode == "M") {
        dispatch(
          leaveAppoval({
            data: {
              RecordID: recID,
              ManagerID: EMPID,
              EmployeeID: params.parentID,
              Type: "RG",
              Status:
                values.AppliedStatus == "AP"
                  ? "Y"
                  : values.AppliedStatus == "QR"
                    ? values.AppliedStatus
                    : "N",
              Reason: values.comments,
              Source: "M",
            },
          })
        );
        dispatch(mailNotify({
          RecordID: recID,
          ManagerID: EMPID,
          EmployeeID: params.parentID,
          Type: "RG",
          Status:
            values.AppliedStatus == "AP"
              ? "Y"
              : values.AppliedStatus == "QR"
                ? values.AppliedStatus
                : "N",
          Reason: values.comments,
          Source: "M",

        }));
      }
      dispatch(
        fetchExplorelitview(
          "TR219",
          "Regularization",
          `EmployeeID='${EMPID}'`,
          ""
        )
      );
      toast.success(response.payload.Msg);
      navigate(-1);
      // selectCellRowData({ rowData: {}, mode: "A", field: "" });
      resetForm();
    } else {
      setLoading(false);
      toast.error(response.payload.Msg);
    }
  };
  const handleDateChange = (
    e,
    setFieldValue,
    setCheckIN
  ) => {
    const value = e.target.value;

    // allow clear
    if (!value) {
      setFieldValue("CheckInDate", "");
      setCheckIN("");
      return;
    }

    // only full valid date
    if (
      !/^\d{4}-\d{2}-\d{2}$/.test(value)
    ) {
      return;
    }

    const [year, month, day] =
      value.split("-");

    if (
      Number(month) < 1 ||
      Number(month) > 12 ||
      Number(day) < 1 ||
      Number(day) > 31
    ) {
      return;
    }

    setCheckIN(value);

    setFieldValue(
      "CheckInDate",
      value
    );
  };

  const handleDateBlur = (
    e,
    handleBlur,
    dispatch,
    EMPID,
    setResponseMsg
  ) => {
    handleBlur(e);

    const selectedDate = e.target.value;

    // allow only complete YYYY-MM-DD
    if (
      !selectedDate ||
      !/^\d{4}-\d{2}-\d{2}$/.test(selectedDate)
    ) {
      return;
    }

    const [year, month, day] =
      selectedDate.split("-");

    // additional validation
    if (
      Number(year) < 1900 ||
      Number(year) > 9999 ||
      Number(month) < 1 ||
      Number(month) > 12 ||
      Number(day) < 1 ||
      Number(day) > 31
    ) {
      return;
    }

    dispatch(
      RegGetData({
        data: {
          EmployeeID: EMPID,
          CheckInDate: selectedDate,
        },
      })
    ).then((response) => {
      setResponseMsg(
        response?.payload?.Msg || ""
      );
    });
  };
  async function fileUpload(file, EMPID, action, id, purpose) {
    setimgLoading(true);
    console.log("🚀 ~ fileUpload ~ file:", file);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("empId", data.EmployeeID);
    formData.append("appId", data.RecordID);
    formData.append("type", "R");
    formData.append("source", "Self");
    formData.append("action", action);
    formData.append("id", id);
    formData.append("purpose", purpose ? purpose : "");
    console.log("🚀 ~ fileUpload ~ formData:", formData);
    const respose = await dispatch(attachmentPost({ data: formData }));

    if (respose.payload.success) {
      toast.success(respose.payload.message);

      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: EMPID,
            appId: recID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setimgLoading(false));
    } else {
      toast.success(respose.payload.message);
    }

    console.log("🚀 ~ fileUpload ~ respose:", respose);
  }
  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      {imgloading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
        <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography variant="h3" sx={{ marginLeft: "10px", fontSize: "19px",color: "#0000D1" }}>
              {is003Subscription ? "Attendance Correction" : "Regularization"}
            </Typography>
          </Box>
          <Box display="flex">
            <Tooltip title="Close">
              <IconButton color="error" onClick={() => fnLogOut("Close")}>
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton>

                <LogoutOutlinedIcon
                  color="error"
                  onClick={() => fnLogOut("Logout")}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      {!getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {mode === "IM" && (
            <Box
              display="flex"
              padding={1}
              justifyContent="flex-end"
              mt="2px"
              gridColumn="span 4"
              gap={2}
              marginBottom={-5}
            >
              <IconButton
                onClick={() => setShowImage(prev => !prev)}
                sx={{ padding: '12px' }}
              >
                <ArrowDownwardIcon sx={{ color: "blue", marginBottom: "8px" }} />
              </IconButton>
            </Box>)}
          <Formik
            initialValues={RegInitialValue}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                REGfnSave(values);
              }, 100);
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  {mode == "M" && (
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="Name"
                      name="Name"
                      value={values.Name}
                      label="Name"
                      focused
                      inputProps={{ readOnly: true }}
                    //sx={{ gridColumn: "span 2" }}
                    />
                  )}

                  <TextField
                    disabled={
                      mode === "M" || (
                        mode == "E" &&
                        values.Status != "AL" &&
                        values.Status != "QR"
                      )
                    }
                    name="MonthDate"
                    type="date"
                    id="MonthDate"
                    label="Regularization Date"
                    variant="standard"
                    focused
                    inputFormat="YYYY-MM-DD"
                    value={values.MonthDate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.MonthDate && !!errors.MonthDate}
                    helperText={touched.MonthDate && errors.MonthDate}
                    InputLabelProps={{ shrink: true }}
                  />

                  <TextField
                    disabled={
                      mode === "M" || (
                        mode == "E" &&
                        values.Status != "AL" &&
                        values.Status != "QR"
                      )
                    }
                    name="CheckInDate"
                    type="date"
                    id="CheckInDate"
                    label={
                      <>
                        Check In Date<span style={{ color: "red", fontSize: "20px" }}> * </span>
                      </>
                    }
                    variant="standard"
                    focused
                    inputFormat="YYYY-MM-DD"
                    value={values.CheckInDate}
                    InputLabelProps={{ shrink: true }}
                    // onBlur={handleBlur}
                    // onChange={(e) => {
                    //   const selectedDate = e.target.value;
                    //   if (selectedDate) {
                    //     dispatch(
                    //       RegGetData({
                    //         data: {
                    //           EmployeeID: EMPID,
                    //           CheckInDate: selectedDate,
                    //         },
                    //       })
                    //     ).then((response) => {
                    //       const msg = response.payload.Msg;
                    //       if (msg) {
                    //         setResponseMsg(msg);
                    //       } else {
                    //         setResponseMsg(""); // Clear if no message
                    //       }
                    //     });
                    //   }
                    //   setCheckIN(selectedDate);
                    //   setFieldValue("CheckInDate", selectedDate);
                    // }}
                    onChange={(e) =>
                      handleDateChange(
                        e,
                        setFieldValue,
                        setCheckIN
                      )
                    }
                    onBlur={(e) =>
                      handleDateBlur(
                        e,
                        handleBlur,
                        dispatch,
                        EMPID,
                        setResponseMsg
                      )
                    }
                    error={!!touched.CheckInDate && !!errors.CheckInDate}
                    helperText={touched.CheckInDate && errors.CheckInDate}
                  //sx={{ gridColumn: "span 2" }}
                  />
                  {!showImage ? <React.Fragment>
                    <TextField
                      disabled={
                        mode === "M" || (
                          mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "QR"
                        )
                      }
                      name="EmplyeeCheckInDateTime"
                      type="time"
                      id="EmplyeeCheckInDateTime"
                      label="Check In Time"
                      inputFormat="HH:mm"
                      // inputFormat="HH:mm:aa"
                      variant="standard"
                      value={values.EmplyeeCheckInDateTime}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      focused
                    //sx={{ gridColumn: "span 2" }}
                    />

                    <TextField
                      disabled={
                        mode === "M" || (
                          mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "QR"
                        )
                      }
                      name="CheckOutDate"
                      type="date"
                      id="CheckOutDate"
                      label="Check Out Date"
                      variant="standard"
                      focused
                      inputFormat="YYYY-MM-DD"
                      value={values.CheckOutDate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        min: values.CheckInDate,
                      }}
                      error={!!touched.CheckOutDate && !!errors.CheckOutDate}
                      helperText={touched.CheckOutDate && errors.CheckOutDate}
                    //sx={{ gridColumn: "span 2", background: "#f5f5f5" }}
                    />

                    <TextField
                      disabled={
                        mode === "M" || (
                          mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "QR"
                        )
                      }
                      name="EmplyeeCheckOutDateTime"
                      type="time"
                      id="EmplyeeCheckOutDateTime"
                      label="Check Out Time"
                      inputFormat="HH:mm:aa"
                      value={values.EmplyeeCheckOutDateTime}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      focused
                      variant="standard"
                    />

                    {/* <FormControl
                     
                    >
                      <InputLabel id="Status">
                        {
                          <span>
                            Status
                            <span style={{ color: "red", fontSize: "18px" }}>*</span>
                          </span>

                        }
                      </InputLabel> */}
                    <TextField
                      labelId="demo-simple-select-filled-label"
                      id="Status"
                      variant="standard"
                      type="text"
                      label={
                        <span>
                          Status
                          <span style={{ color: "red", fontSize: "18px" }}>*</span>
                        </span>

                      }
                      name="Status"
                      value={values.Status}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      disabled={
                        mode === "M" || (
                          mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "QR"
                        )
                      }
                      error={!!touched.Status && !!errors.Status}
                      helperText={touched.Status && errors.Status}
                      // required
                      select
                      focused
                    >
                      <MenuItem value="R">Present</MenuItem>
                      <MenuItem value="A">Absent</MenuItem>
                      <MenuItem value="W">WeekOff</MenuItem>
                      <MenuItem value="I">Irregular</MenuItem>
                      <MenuItem value="L">Leave</MenuItem>
                    </TextField>
                    {/* </FormControl> */}
                    {mode == "M" && (
                      <TextField
                        select
                        label={
                          <>
                            Applied Status<span style={{ color: "red", fontSize: "20px" }}> * </span>
                          </>
                        }
                        id="AppliedStatus"
                        name="AppliedStatus"
                        value={values.AppliedStatus}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.AppliedStatus && !!errors.AppliedStatus}
                        helperText={touched.AppliedStatus && errors.AppliedStatus}
                        focused
                        variant="standard"
                      >
                        {mode != "M" && <MenuItem value="AL">Applied</MenuItem>}
                        <MenuItem disabled={mode != "M"} value="AP">
                          Approved
                        </MenuItem>
                        <MenuItem disabled={mode != "M"} value="RJ">
                          Rejected
                        </MenuItem>
                        {mode == "M" && <MenuItem value="QR">Query</MenuItem>}
                      </TextField>
                    )}
                    <FormControl focused variant="standard">
                      {mode == "M" && (
                        <TextField
                          fullWidth
                          variant="outlined"
                          type="text"
                          label={
                            <>
                              Manager Comments
                              <span
                                style={{ color: "red", fontSize: "20px" }}
                              >
                                {" "}
                                *{" "}
                              </span>
                            </>
                          }
                          // label="Manager Comments"
                          // required
                          multiline
                          rows={6}
                          value={values.managerComments}
                          id="managerComments"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={
                            !!touched.managerComments &&
                            !!errors.managerComments
                          }
                          helperText={
                            touched.managerComments && errors.managerComments
                          }
                          name="managerComments"
                          sx={{
                            gridColumn: "span 2",
                          }}
                          focused
                        />
                      )}

                      <TextField
                        disabled={
                          mode === "M" || (
                            mode == "E" &&
                            values.Status != "AL" &&
                            values.Status != "QR"
                          )
                        }
                        fullWidth
                        variant="standard"
                        type="text"
                        label={
                          <>
                            Remarks<span style={{ color: "red", fontSize: "20px" }}> * </span>
                          </>
                        }
                        value={values.remarks}
                        id="remarks"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="remarks"
                        error={!!touched.remarks && !!errors.remarks}
                        helperText={touched.remarks && errors.remarks}
                        focused
                        // required
                        inputProps={{ maxLength: 90 }}
                      />

                      {mode == "E" && values.AppliedStatus == "AP" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                          Your Regularization Request has been Approved.
                        </Alert>
                      )}
                      {mode == "E" && values.AppliedStatus == "RJ" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                          Your Regularization Request has been Rejected.
                        </Alert>
                      )}
                      {mode == "E" && values.AppliedStatus == "QR" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                          Your Regularization Request has been Queried.
                        </Alert>
                      )}
                    </FormControl>
                  </React.Fragment> : false}
                </Box>
                {responseMsg && (
                  <div
                    style={{
                      color: "#856404",
                      backgroundColor: "#fff3cd",
                      border: "1px solid #ffeeba",
                      padding: "8px",
                      borderRadius: "4px",
                      fontSize: "0.875rem",
                      marginTop: "4px",
                    }}
                  >
                    {responseMsg}
                  </div>
                )}

                <Box
                  display="flex"
                  padding={1}
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                //   display="flex" justifyContent="end" padding={1} gap={2}
                >
                  {/* {mode === "E" ? (
                    <Box display="flex" alignItems="center" gap={1}>
                      <FileUploadIconButton onFileSelect={fileUpload} />
                    </Box>
                  ) : null} */}
                  {/* {mode === "IM" ? (
                    <Button variant="contained" color="info" onClick={() => setShowImage(prev => !prev)}> {showImage ? 'Show Detail' : 'Hide Detail'}</Button>
                  ) : null} */}
                  {mode == "IM" && (
                    <>
                      <TextField
                        name="purpose"
                        type="text"
                        id="purpose"
                        label="Purpose"
                        variant="standard"
                        focused
                        value={values.purpose}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.purpose && !!errors.purpose}
                        helperText={touched.purpose && errors.purpose}
                        sx={{ gridColumn: "span 2", height: "15px", marginBottom: "25px" }}
                        InputLabelProps={{ shrink: true }}

                      />

                      <Box display="flex" alignItems="center" gap={1}>
                        <FileUploadIconButton onFileSelect={(file) => {
                          fileUpload(
                            file,
                            data.EmployeeID,
                            "upload",
                            "",
                            values.purpose
                          )
                          setFieldValue("purpose", "");
                        }}
                        />
                      </Box>
                    </>
                  )}
                  {mode != "M" &&
                    (values.Status == "AL" ||
                      values.Status == "QR" ||
                      mode == "A") && (
                      <LoadingButton
                        disabled={mode == "IM"}
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={loading}
                      >
                        Save
                      </LoadingButton>
                    )}
                  {mode == "M" && (
                    <LoadingButton
                      disabled={mode == "IM"}
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={loading}
                    >
                      Save
                    </LoadingButton>
                  )}
                  {mode != "M" && values.Status == "AL" && (
                    <Button
                      color="error"
                      variant="contained"
                      disabled={mode == "IM"}
                      onClick={() => {
                        Swal.fire({
                          title: errorMsgData.Warningmsg.Delete,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            REGfnSave(values, resetForm, "harddelete");
                            // navigate(-1);
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )}
                  {mode == "M" && (
                    <Button
                      color="error"
                      variant="contained"
                      disabled={mode == "IM"}
                      onClick={() => {
                        Swal.fire({
                          title: errorMsgData.Warningmsg.Delete,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            REGfnSave(values, resetForm, "harddelete");
                            // navigate(-1);
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )}
                  {/* <LoadingButton
                    loading={loading}
                    variant="contained"
                    color="secondary"
                    type="submit"
                  >
                    SAVE
                  </LoadingButton>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => {
                      Swal.fire({
                        title: `Do you want Delete?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Confirm",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          REGfnSave(values, resetForm, "harddelete");
                          navigate(-1);
                        } else {
                          return;
                        }
                      });
                    }}
                  >
                    Delete
                  </Button> */}

                  <Button
                    variant="contained"
                    color="warning"
                    onClick={() => {
                      navigate(
                        -1
                        // `/Apps/Secondarylistview/TR086/Finance Entry/${parentID}`
                      );
                    }}
                  >
                    CANCEL
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
          <FileListPopup
            open={open}
            onClose={() => setOpen(false)}
            appId={recID}
            empId={EMPID}
          />
        </Paper>
      ) : (
        false
      )}
      {mode === "IM" && files.length > 0 ? (
        <Box mt={2}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            {/* <Typography variant="h6" gutterBottom>
                     Uploaded Files
                   </Typography> */}
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}>
                      <strong>SL#</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Uploaded Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Filename</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Purpose</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Source</strong>
                    </TableCell>
                    <TableCell>
                      <strong>View</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.purpose}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="delete">
                            <IconButton
                              color="error"
                              onClick={() => fileUpload(
                                file.filename,
                                data.EmployeeID,
                                "delete",
                                file.id,
                                file.purpose
                              )}
                              size="small"
                            >
                              <DeleteForeverIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}
    </React.Fragment>
  );
};
export default EditRegularization;
